export default __webpack_public_path__ + "assets/images/Settings-7978c231341df0baec8cbc057d4e2e9f.svg";